import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/core/_config/app.config';
import { ApiServiceExtension } from 'src/app/core/extension/apiServiceExtension';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LevelModel } from 'src/app/models/afs/level.model';
import { CustomResponse } from 'src/app/interfaces/CustomResponse';

@Injectable({
   providedIn: 'root',
})
export class LevelService extends ApiServiceExtension {
   constructor(protected config: AppConfig, public http: HttpClient) {
      super(config, http);
   }

   public getLevelByEntityId(entityId: string): Observable<CustomResponse<LevelModel>> {
      let url = `${this.API_URL}Level/GetLevelByEntityId`;
      return this.http.get<CustomResponse<LevelModel>>(url, {
         params: { entityId: entityId },
      });
   }

   public GetByPeriodId(periodId: string): Observable<CustomResponse<LevelModel>> {
      let url = `${this.API_URL}Level/GetByPeriodId`;
      return this.http.get<CustomResponse<LevelModel>>(url, {
         params: { periodId: periodId },
      });
   }

   public getByEntityIdAndSubAccount(entityId: string, subAccount: string): Observable<CustomResponse<LevelModel>> {
      let url = `${this.API_URL}Level/GetByEntityIdAndSubAccount`;
      return this.http.get<CustomResponse<LevelModel>>(url, {
         params: {
            entityId: entityId,
            subAccount: subAccount,
         },
      });
   }
}
